<template>
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery" :model="queryParam" >
          <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.activity.activitycode']">
             <a-input  maxLength="50"  v-model="queryParam.activitycode" :placeholder="this.language['cs.activity.activitycode']"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.activity.activityname']">
              <a-input  maxLength="50"  v-model="queryParam.activityname" :placeholder="this.language['cs.activity.activityname']"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.venue.venuename']">
             <a-input  maxLength="50"  v-model="queryParam.venuenames" :placeholder="this.language['cs.venue.venuename']"></a-input>
            </a-form-item>
          </a-col>
          
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.activity.startenddate']">
              <a-date-picker  :placeholder="language['common.chooseStartDate']" format="YYYY-MM-DD" value-format="YYYY-MM-DD"  class="query-group-cust" v-model="queryParam.startdate"></a-date-picker>
                <span class="query-group-split-cust"></span>
                <a-date-picker  :placeholder="language['common.chooseEndDate']" format="YYYY-MM-DD" value-format="YYYY-MM-DD"  class="query-group-cust" v-model="queryParam.enddate"></a-date-picker>
       
            </a-form-item>
          </a-col>
          
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{this.language['common.searchButton']}}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{this.language['common.resetButton']}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->
      
      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button @click="handleSeatAssign" type="primary" icon="edit"  >{{  this.language['cs.seatassign']}}</a-button>  
        <a-button @click="handleImport" type="primary" icon="import">{{  this.language['cs.importseatassign']}}</a-button>
        <!-- 高级查询区域 -->

      </div>
  
      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>
  
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="sysacid"
          class="j-table-force-nowrap"
          :scroll="{x:1800}"
          :dataSource="dataSource"
          :pagination="ipagination"
          :columns="columns"
          :loading="loading"
          
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,type:'radio'}"
          @change="handleTableChange">
          <template slot="htmlSlot" slot-scope="text">
            <div v-html="text"></div>
          </template>
          <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)" >座位分配</a>
  
            <!-- <a-divider type="vertical" /> -->
         
          </span>
        </a-table>
      </div>
 
      <j-modal ref="SeatAssignForm"
    :title="titleSetSeat"
    width="100%"
    :visible="seatvisible"
    switchFullscreen
    @ok="handleSeatOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleSeatCancel"
    cancelText="关闭">
    <template >

   <seat-assign-form></seat-assign-form>
    </template>
      </j-modal>

      <import-seat-modal ref="importModal" :url="getImportUrl()" @ok="importOk"></import-seat-modal>

      
      <j-modal ref="ViewSeatFrom"
    :title="titleSetSeat"
    width="100%"
    :visible="viewseatvisible"
    switchFullscreen
    @ok="handleViewSeatOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleViewSeatCancel"
    cancelText="关闭">
    <template >

   <view-seat-form></view-seat-form>
    </template>
      </j-modal>
    </a-card>
  </template>
  
  <script>
    import { httpAction, getAction } from '@/api/manageChooseSeat'
    import '@/assets/less/TableExpand.less'
    import { JeecgListMixin } from '@/views/chooseSeat/mixins/JeecgListMixin.js'
    import SeatAssignForm from './modules/SeatAssignForm'
    import ImportSeatModal from './modules/ImportSeatModal'
    import ViewSeatForm from './modules/ViewSeatForm'

    export default {
      name: "SeatAssignList",
      mixins:[JeecgListMixin],
      components: {
        SeatAssignForm,
        ImportSeatModal,
        ViewSeatForm
      },
      data() {
        return {
          description: '座位分配信息',
          seatvisible:false,
          viewseatvisible:false,
          titleSetSeat:"",
          // 表头
         
          url: {
            list: "/ActivityInfo/seatAssignList",
            import: "/ActivityInfo/ImportSeatAssign"
            
          },
          operation :{
           titleSetSeat:"add",
           sysactivityid:"",
           sysvenueid:""
           },
        }
      },
      created() {
      },
      mounted(){
      
      }, 
      provide(){
        return{
         operation:this.operation
        }
       }, 
      watch:{

      },
      computed: {
        language() {
          return this.$store.getters.language
        },
        columns() {
          if (this.language) {
            return  [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:this.language['cs.activity.activitycode'],
              align:"center",
              width:150,
              ellipsis: true,
              dataIndex: 'activitycode'
            },  
            {
              title:this.language['cs.activity.activityname'],
              align:"left",
              width:150,
              ellipsis: true,
              dataIndex: 'activityname'
            },  
            {
              title:this.language['cs.venue.venuename'],
              align:"left",
              width:150,
              dataIndex: 'venuenames'
            },
             {
              title:this.language['cs.activity.startdate'],
              align:"center",
              width:150,
              ellipsis: true,
              dataIndex: 'startdate'
            },
            {
              title:this.language['cs.activity.enddate'],
              align:"center",
              width:150,
              ellipsis: true,
              dataIndex: 'enddate'
            },
            {
              title:this.language['cs.activity.seatstartdate'],
              align:"center",
              width:150,
              ellipsis: true,
              dataIndex: 'seatstartdate'
            },
            {
              title:this.language['cs.activity.seatenddate'],
              align:"center",
              width:150,
              ellipsis: true,
              dataIndex: 'seatenddate'
            }, 
            {
              title:this.language['cs.seat.persontotalqty'],
              align:"right",
              width:150,
              dataIndex: 'persontotalqty'
            },  
            {
              title:this.language['cs.seat.seattotalqty'],
              align:"right",
              width:150,
              dataIndex: 'seattotalqty'
            }, 
            {
              title: '操作',
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:147,
              scopedSlots: { customRender: 'action' },
            }
          ]
          }
        }
      },
      methods: {
        searchQuery() {
        this.loadData(1);
        },
        handleImport(){
          if (this.selectedRowKeys.length != 1) {
                this.$message.warning('请选择一条记录！');
                return;
              } 
              
        this.operation.titleSetSeat=this.selectionRows[0].activityname +"-"+this.selectionRows[0].venuenames  ;
        this.operation.sysactivityid=this.selectionRows[0].sysactivityid ;
        this.operation.sysvenueid=this.selectionRows[0].sysvenueid ;
        this.$refs.importModal.show()
      }, 
      getImportUrl(){
          return this.url.import+"?sysactivityid="+this.operation.sysactivityid+"&sysvenueid="+this.operation.sysvenueid;
       },
        handleSeatOk()
        {  this.seatvisible=false;},
        handleSeatCancel()
        {  this.seatvisible=false;},
        handleViewSeatOk()
        {  this.viewseatvisible=false;},
        handleViewSeatCancel()
        {  this.viewseatvisible=false;},


        handleSeatAssign()
        {  
           if (this.selectedRowKeys.length != 1) {
                this.$message.warning('请选择一条记录！');
                return;
              } 
          this.titleSetSeat= this.selectionRows[0].activityname ;
          this.operation.titleSetSeat=this.selectionRows[0].activityname +"-"+this.selectionRows[0].venuenames  ;
          this.operation.sysactivityid=this.selectionRows[0].sysactivityid ;
          this.operation.sysvenueid=this.selectionRows[0].sysvenueid ;
          this.seatvisible=true;
        },
        handleEdit(record)
        {
          this.titleSetSeat= record.activityname ;
          this.operation.titleSetSeat=record.activityname +"-"+record.venuenames  ;
          this.operation.sysactivityid=record.sysactivityid ;
          this.operation.sysvenueid=record.sysvenueid ;
          this.operation.activityinfo=record ;
          this.seatvisible=true;
        },
        handleLook(record)
        {
          this.titleSetSeat= record.activityname ;
          this.operation.sysactivityid=record.sysactivityid ;
          this.operation.sysvenueid=record.sysvenueid ;
          this.viewseatvisible=true;
        }

      }
    }
  </script>
  <style scoped>
    @import '~@assets/less/common.less';
  </style>